<template>
  <div class="is-flex is-align-items-flex-start" style="margin-top: 10px;">
    <div class="is-flex is-align-items-center">
      <a @click="removeArea" class="button is-danger">הסר</a>
      <div class="horizontal_space"></div>
      <select @input="zoneSelected($event.target.value)" :value="zone_id" dir="rtl">
        <option>NOT SELECTED</option>
        <option v-for="zone in zones_and_regions.Zones" :value="zone.Value" :key="zone.Value">{{ zone.Text }}</option>
      </select>
    </div>
    <div class="horizontal_space"></div>
    <div dir="ltr">
      <checkbox v-for="(region, index) in selected_zone_regions" v-model="selected_zone_regions[index].is_selected" :checked="region.is_selected" @input="updateParent" :key="region.RegionId" style="margin-right: 10px;">
        {{ region.Name }}
        <br>
        <br>
      </checkbox>
    </div>
  </div>
</template>
<script>
import Checkbox from '@/components/Checkbox'
export default {
  name: 'outsource-drushim-area-list-item',
  props: ['area', 'zones_and_regions'],
  data () {
    return {
      zone_id: this.area.zone_id,
      selected_zone_regions: []
    }
  },
  watch: {
    area () {
      this.zone_id = this.area.zone_id
    }
  },
  created () {
    if (!this.isAreaExists()) {
      return
    }
    this.zoneSelected(this.area.zone_id)
  },
  methods: {
    zoneSelected (zone_id) {
      this.zone_id = zone_id
      this.selected_zone_regions = this.zones_and_regions.Regions.filter(region => region.ZoneId == zone_id)
      this.selected_zone_regions.map(region => {
        region.is_selected = this.isRegionSelected(region)
        return region
      })
      this.updateParent()
    },
    isAreaExists () {
      return this.area.zone_id != undefined
    },
    isRegionSelected (region_to_compare) {
      if (this.isAreaExists()) {
        return this.area.regions.filter(region => region.is_selected && (region.RegionId == region_to_compare.RegionId)).length == 1
      }
      return true
    },
    updateParent () {
      this.$emit('input', { zone_id: this.zone_id, regions: this.selected_zone_regions })
    },
    removeArea () {
      this.$emit('remove_area')
    }
  },
  components: {
    Checkbox
  }
}
</script>
